import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1c43afe9&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=1c43afe9&lang=postcss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43afe9",
  null
  
)

export default component.exports